export enum IssueType {
    TransformerConditionStatusChanged = 1,
    OilAnalysisComing,
    OilAnalysisOverdue,
    NoActionComponent,
    GeneratorConditionStatusChanged,
    ActionOverdue = 6,
}

export interface IssueTypeOption {
    labelKey: string
    value: IssueType
}

export const IssueTypes: IssueTypeOption[] = [
    {
        labelKey: 'transformers.portfolioOverview.flaggedTransformers.issueTypes.TransformerConditionStatusChanged',
        value: IssueType.TransformerConditionStatusChanged,
    },
    {
        labelKey: 'transformers.portfolioOverview.flaggedTransformers.issueTypes.OilAnalysisComing',
        value: IssueType.OilAnalysisComing,
    },
    {
        labelKey: 'transformers.portfolioOverview.flaggedTransformers.issueTypes.OilAnalysisOverdue',
        value: IssueType.OilAnalysisOverdue,
    },
    {
        labelKey: 'transformers.portfolioOverview.flaggedTransformers.issueTypes.NoActionComponent',
        value: IssueType.NoActionComponent,
    },
    {
        labelKey: 'generators.portfolioOverview.flaggedGenerators.issueTypes.GeneratorConditionStatusChanged',
        value: IssueType.GeneratorConditionStatusChanged,
    },
    {
        labelKey: 'transformers.portfolioOverview.flaggedTransformers.issueTypes.ActionOverdue',
        value: IssueType.ActionOverdue,
    },
] as const

const filterIssues = (selectedIssues: IssueType[]) => {
    const issueMap = new Map(IssueTypes.map((issue) => [issue.value, issue]))

    return selectedIssues
        .map((value) => issueMap.get(value))
        .filter((issue) => issue !== undefined) as IssueTypeOption[]
}

export const TransformerIssueTypes = filterIssues([
    IssueType.TransformerConditionStatusChanged,
    IssueType.OilAnalysisComing,
    IssueType.OilAnalysisOverdue,
    IssueType.NoActionComponent,
    IssueType.ActionOverdue,
])

export const GeneratorIssueTypes = filterIssues([
    IssueType.GeneratorConditionStatusChanged,
    IssueType.NoActionComponent,
    IssueType.ActionOverdue,
])